/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from './environments/environment';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
export const msalConfig: Configuration = {
    auth: {
        clientId: 'adc92964-a30c-4e6f-b810-a66b690be191', // This is the ONLY mandatory field that you need to supply.
        authority: 'https://emainrun.ciamlogin.com/', // Replace the placeholder with your tenant subdomain
        redirectUri: window.location.origin + '/app', //'/', // Points to window.location.origin by default. You must register this URI on Microsoft Entra admin center/App Registration.
        postLogoutRedirectUri: '/', // Points to window.location.origin by default.
      },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge. Remove this line to use Angular Universal
    },
    system: {
        loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
                console.log(message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false,
        },
    },
};
export const loginRequest = {
    scopes: []
};
